module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-gun-metal-mill-finish-721-panel.7360e10a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-gun-metal-mill-finish-721-panel.jpg
// module id = 1130
// module chunks = 37